const echarts = require('echarts')

export default (ctx, inject) => {
  inject('echarts', echarts)
  ctx.$echarts = echarts
}
